import { CALL_API, Schemas } from '../../common/middleware/api';

export const MESSAGE_TEMPLATES_REQUEST = 'MESSAGE_TEMPLATES_REQUEST';
export const MESSAGE_TEMPLATES_SUCCESS = 'MESSAGE_TEMPLATES_SUCCESS';
export const MESSAGE_TEMPLATES_FAILURE = 'MESSAGE_TEMPLATES_FAILURE';

export const MESSAGE_TEMPLATE_FETCH_REQUEST = 'MESSAGE_TEMPLATE_GET_REQUEST';
export const MESSAGE_TEMPLATE_FETCH_SUCCESS = 'MESSAGE_TEMPLATE_GET_SUCCESS';
export const MESSAGE_TEMPLATE_FETCH_FAILURE = 'MESSAGE_TEMPLATE_GET_FAILURE';

export const MESSAGE_TEMPLATE_CREATE_REQUEST = 'MESSAGE_TEMPLATE_CREATE_REQUEST';
export const MESSAGE_TEMPLATE_CREATE_SUCCESS = 'MESSAGE_TEMPLATE_CREATE_SUCCESS';
export const MESSAGE_TEMPLATE_CREATE_FAILURE = 'MESSAGE_TEMPLATE_CREATE_FAILURE';

export const MESSAGE_TEMPLATE_UPDATE_REQUEST = 'MESSAGE_TEMPLATE_UPDATE_REQUEST';
export const MESSAGE_TEMPLATE_UPDATE_SUCCESS = 'MESSAGE_TEMPLATE_UPDATE_SUCCESS';
export const MESSAGE_TEMPLATE_UPDATE_FAILURE = 'MESSAGE_TEMPLATE_UPDATE_FAILURE';

export const MESSAGE_TEMPLATE_DELETE_REQUEST = 'MESSAGE_TEMPLATE_DELETE_REQUEST';
export const MESSAGE_TEMPLATE_DELETE_SUCCESS = 'MESSAGE_TEMPLATE_DELETE_SUCCESS';
export const MESSAGE_TEMPLATE_DELETE_FAILURE = 'MESSAGE_TEMPLATE_DELETE_FAILURE';

export const AD_HOC_MESSAGE_TEMPLATES_REQUEST = 'AD_HOC_MESSAGE_TEMPLATES_REQUEST';
export const AD_HOC_MESSAGE_TEMPLATES_SUCCESS = 'AD_HOC_MESSAGE_TEMPLATES_SUCCESS';
export const AD_HOC_MESSAGE_TEMPLATES_FAILURE = 'AD_HOC_MESSAGE_TEMPLATES_FAILURE';

export const MESSAGE_TEMPLATE_TAGS_REQUEST = 'MESSAGE_TEMPLATE_TAGS_REQUEST';
export const MESSAGE_TEMPLATE_TAGS_SUCCESS = 'MESSAGE_TEMPLATE_TAGS_SUCCESS';
export const MESSAGE_TEMPLATE_TAGS_FAILURE = 'MESSAGE_TEMPLATE_TAGS_FAILURE';

export const loadMessageTemplates = (options) => ({
	[CALL_API]: {
		types: [MESSAGE_TEMPLATES_REQUEST, MESSAGE_TEMPLATES_SUCCESS, MESSAGE_TEMPLATES_FAILURE],
		endpoint: 'api/messageTemplates',
		request: options,
		schema: Schemas.MESSAGE_TEMPLATE_ARRAY
	}
});

export const fetchMessageTemplate = (id) => ({
	[CALL_API]: {
		types: [MESSAGE_TEMPLATE_FETCH_REQUEST, MESSAGE_TEMPLATE_FETCH_SUCCESS, MESSAGE_TEMPLATE_FETCH_FAILURE],
		endpoint: `api/messageTemplates/${id}`,
		schema: Schemas.MESSAGE_TEMPLATE
	}
});

export const createMessageTemplate = (messageTemplate, history) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [MESSAGE_TEMPLATE_CREATE_REQUEST, MESSAGE_TEMPLATE_CREATE_SUCCESS, MESSAGE_TEMPLATE_CREATE_FAILURE],
			endpoint: 'api/messageTemplates',
			method: 'POST',
			request: messageTemplate,
			schema: Schemas.MESSAGE_TEMPLATE,
			form: 'messageTemplate',
			transition: {
				history,
				successPath: (response) => {
					return `/messageTemplates/${response.result}`;
				}
			},
			onSuccessEvent: () => {
				if (!messageTemplate.isSystem) {
					dispatch(loadAdHocMessageTemplates());	// reload ad-hoc message templates for "Send email" dialog
				}
			}
		}
	});
};

export const updateMessageTemplate = (id, messageTemplate) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [MESSAGE_TEMPLATE_UPDATE_REQUEST, MESSAGE_TEMPLATE_UPDATE_SUCCESS, MESSAGE_TEMPLATE_UPDATE_FAILURE],
			endpoint: `api/messageTemplates/${id}`,
			method: 'PUT',
			request: messageTemplate,
			schema: Schemas.MESSAGE_TEMPLATE,
			form: 'messageTemplate',
			onSuccessEvent: () => {
				if (!messageTemplate.isSystem) {
					dispatch(loadAdHocMessageTemplates());	// reload ad-hoc message templates for "Send email" dialog
				}
			}
		}
	});
};

export const deleteMessageTemplate = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [
			MESSAGE_TEMPLATE_DELETE_REQUEST,
			MESSAGE_TEMPLATE_DELETE_SUCCESS,
			MESSAGE_TEMPLATE_DELETE_FAILURE
		],
		endpoint: `api/messageTemplates/${id}`,
		method: 'DELETE',
		onSuccessEvent
	}
});

export const loadAdHocMessageTemplates = () => ({
	[CALL_API]: {
		types: [AD_HOC_MESSAGE_TEMPLATES_REQUEST, AD_HOC_MESSAGE_TEMPLATES_SUCCESS, AD_HOC_MESSAGE_TEMPLATES_FAILURE],
		endpoint: 'api/messageTemplates/adhoc',
		schema: Schemas.AD_HOC_MESSAGE_TEMPLATE_ARRAY
	}
});

// Static catalog of email placeholder tags (groups + which groups apply per template type)
export const loadMessageTemplateTags = () => ({
	[CALL_API]: {
		types: [MESSAGE_TEMPLATE_TAGS_REQUEST, MESSAGE_TEMPLATE_TAGS_SUCCESS, MESSAGE_TEMPLATE_TAGS_FAILURE],
		endpoint: 'api/messageTemplates/tags'
	}
});
